import { render, staticRenderFns } from "./mnjybdMore.vue?vue&type=template&id=274d5432&scoped=true&"
import script from "./mnjybdMore.vue?vue&type=script&lang=js&"
export * from "./mnjybdMore.vue?vue&type=script&lang=js&"
import style0 from "./mnjybdMore.vue?vue&type=style&index=0&id=274d5432&lang=less&scoped=true&"
import style1 from "./mnjybdMore.vue?vue&type=style&index=1&id=274d5432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d5432",
  null
  
)

export default component.exports